import { render } from "./EditUserCredentialsModal.vue?vue&type=template&id=1133a9f0&scoped=true&ts=true"
import script from "./EditUserCredentialsModal.vue?vue&type=script&lang=ts"
export * from "./EditUserCredentialsModal.vue?vue&type=script&lang=ts"

import "./EditUserCredentialsModal.vue?vue&type=style&index=0&id=1133a9f0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1133a9f0"]])

export default __exports__